<template>
  <el-dialog title="请购单转采购订单" :close-on-click-modal="false" :visible.sync="visible" width="92%" append-to-body>
    <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="90px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="请购单号">
            <span>{{ requisitionCode }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="采购单号" prop="purchaseOrderCode">
            <el-input v-model="dataForm.purchaseOrderCode" :disabled="codeReadonly" :placeholder="codeReadonly ? '保存时自动生成' : ''" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订购日期" prop="orderDate">
            <el-date-picker v-model="dataForm.orderDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="供应商" prop="supplierId">
            <el-input v-model="dataForm.supplierName" readonly placeholder="请选择供应商">
              <el-button slot="append" @click="supplierSelectorVisible = true">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model="dataForm.remark" />
      </el-form-item>

      <el-table border :data="dataForm.lines" :header-cell-style="{ background: '#f5f7fa', color: '#606266', textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
        <el-table-column prop="materialCode" label="产品编码" min-width="120" header-align="center" align="left" />
        <el-table-column prop="materialName" label="产品名称" min-width="130" header-align="center" align="left" />
        <el-table-column prop="specs" label="规格" min-width="100" header-align="center" align="left" />
        <el-table-column prop="remainQuantity" label="可转数量" width="100" header-align="center" align="left" />
        <el-table-column prop="quantity" label="订购数量" width="170" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.quantity"
              :min="0"
              :max="Number(scope.row.remainQuantity || 0)"
              :precision="2"
              style="width:100%"
              @change="calcLineAmount(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="price" label="含税单价" width="170" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.price" :min="0" :precision="2" style="width:100%" @change="calcLineAmount(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column prop="tax" label="税点" width="120" header-align="center" align="left">
          <template slot-scope="scope">
            <el-select v-model="scope.row.tax" placeholder="税点" style="width:100%">
              <el-option v-for="item in taxList" :key="item.dictValue" :label="item.dictLabel" :value="Number(item.dictValue)" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryDate" label="交货日期" width="150" header-align="center" align="left">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.deliveryDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="行金额" width="100" header-align="center" align="left" />
        <el-table-column label="操作" width="70" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeLine(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :disabled="submitLoading" @click="submitHandle">生成采购订单</el-button>
    </span>

    <supplier-selector :visible.sync="supplierSelectorVisible" @select="chooseSupplier" />
  </el-dialog>
</template>

<script>
import SupplierSelector from '../../components/SupplierSelector.vue'
import request from '../../api/request'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}

export default {
  components: { SupplierSelector },
  data() {
    return {
      visible: false,
      submitLoading: false,
      codeReadonly: false,
      requisitionId: '',
      requisitionCode: '',
      supplierSelectorVisible: false,
      taxList: [],
      dataForm: {
        purchaseOrderId: '',
        purchaseOrderCode: '',
        orderDate: '',
        supplierId: '',
        supplierName: '',
        remark: '',
        lines: []
      },
      dataRule: {
        purchaseOrderCode: [{
          validator: (rule, value, callback) => {
            if (this.codeReadonly) { callback(); return }
            if (!value || !String(value).trim()) callback(new Error('采购单号不能为空'))
            else callback()
          },
          trigger: 'blur'
        }],
        orderDate: [{ required: true, message: '订购日期不能为空', trigger: 'change' }],
        supplierId: [{ required: true, message: '请选择供应商', trigger: 'change' }]
      }
    }
  },
  methods: {
    init(requisitionId, requisitionCode, excludePurchaseOrderId) {
      this.requisitionId = requisitionId
      this.requisitionCode = requisitionCode || ''
      this.visible = true
      this.submitLoading = false
      this.codeReadonly = false
      this.dataForm = {
        purchaseOrderId: excludePurchaseOrderId || '',
        purchaseOrderCode: '',
        orderDate: today(),
        supplierId: '',
        supplierName: '',
        remark: '',
        lines: []
      }
      this.resolveCode()
      this.loadTaxList().then(() => {
        let url = '/purchase/purchaseRequisition/linesForConvert/' + requisitionId
        if (excludePurchaseOrderId) {
          url += '?excludePurchaseOrderId=' + encodeURIComponent(excludePurchaseOrderId)
        }
        request.get(url).then(res => {
          const list = (res.data && res.data.list) || res.data || []
          const lines = (Array.isArray(list) ? list : []).filter(l => Number(l.remainQuantity) > 0)
          if (!lines.length) {
            this.$message.warning('没有可转采购的明细')
            return
          }
          this.dataForm.lines = lines.map(line => ({
            requisitionLineId: line.requisitionLineId,
            materialId: line.materialId,
            materialCode: line.materialCode,
            materialName: line.materialName,
            specs: line.specs,
            remainQuantity: Number(line.remainQuantity),
            quantity: Number(line.remainQuantity),
            price: null,
            tax: null,
            deliveryDate: line.requiredDate ? String(line.requiredDate).slice(0, 10) : today(),
            amount: 0
          }))
        }).catch(() => {})
      })
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'purchaseOrder' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.dataForm.purchaseOrderCode = data.previewCode
        this.$nextTick(() => {
          if (this.$refs.dataForm) this.$refs.dataForm.clearValidate('purchaseOrderCode')
        })
      }).catch(() => {})
    },
    loadTaxList() {
      return request.get('/sys/dicts', { params: { dictType: 'TAX' } }).then(res => {
        this.taxList = res.data || []
      }).catch(() => { this.taxList = [] })
    },
    chooseSupplier(supplier) {
      this.dataForm.supplierId = supplier.supplierId
      this.dataForm.supplierName = supplier.supplierName
      this.$nextTick(() => {
        this.$refs.dataForm && this.$refs.dataForm.validateField('supplierId')
      })
    },
    validateLines() {
      for (let i = 0; i < this.dataForm.lines.length; i++) {
        const line = this.dataForm.lines[i]
        const rowNo = i + 1
        if (line.quantity == null || Number(line.quantity) <= 0) return `第${rowNo}行：订购数量必须大于0`
        if (line.price == null || line.price === '') return `第${rowNo}行：含税单价不能为空`
        if (line.tax === null || line.tax === undefined || line.tax === '') return `第${rowNo}行：税点不能为空`
        if (!line.deliveryDate) return `第${rowNo}行：交货日期不能为空`
      }
      return ''
    },
    calcLineAmount(row) {
      if (row.price != null && row.quantity != null) {
        row.amount = Number((row.price * row.quantity).toFixed(2))
      }
    },
    removeLine(index) {
      this.dataForm.lines.splice(index, 1)
    },
    submitHandle() {
      if (!this.dataForm.lines.length) {
        this.$message.error('请至少维护一条订单明细')
        return
      }
      const lineErr = this.validateLines()
      if (lineErr) {
        this.$message.error(lineErr)
        return
      }
      this.$refs.dataForm.validate(valid => {
        if (!valid) {
          this.$message.warning('请完善表头：采购单号、订购日期、供应商')
          return
        }
        this.submitLoading = true
        const draft = {
          purchaseOrderCode: this.dataForm.purchaseOrderCode,
          orderDate: this.dataForm.orderDate,
          supplierId: this.dataForm.supplierId,
          supplierName: this.dataForm.supplierName,
          remark: this.dataForm.remark,
          lines: this.dataForm.lines.map(line => ({
            requisitionLineId: line.requisitionLineId,
            materialId: line.materialId,
            materialCode: line.materialCode,
            quantity: line.quantity,
            price: line.price,
            tax: line.tax,
            deliveryDate: line.deliveryDate ? String(line.deliveryDate).slice(0, 10) : null,
            amount: line.amount
          }))
        }
        request.post('/purchase/purchaseRequisition/convertToPo', {
          requisitionId: this.requisitionId,
          draft
        }).then(() => {
          this.$message.success('已生成采购订单（开立状态，请至采购订单确认）')
          this.visible = false
          this.$emit('success')
        }).catch(() => {}).finally(() => { this.submitLoading = false })
      })
    }
  }
}
</script>
